export const ITGCFrameworkId = '790498536';
export const ITGCFrameworkName = 'ITGC';
